import { Router } from '@angular/router';
import { UserApiService } from '@api/user';
import { Injectable } from "@angular/core";
import {
  HttpHandler,
  HttpRequest,
  HttpInterceptor,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/internal/operators";
import { ErrorHandlerService } from "./services/error-handler.service";
import { ErrorModel } from "./models/error-model";

@Injectable({
  providedIn: "root",
})
export class HttpErrorInterceptor implements HttpInterceptor {
  private isRedirecting = false;

  constructor(private errorHandler: ErrorHandlerService, private userApi: UserApiService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error) => {
        const errBody = error && error.error ? error.error : null;
        const expiredToken =
          error?.status === 401 ||
          errBody?.error === 'EXPIRED_TOKEN' ||
          errBody?.error_description === 'EXPIRED_TOKEN' ||
          (errBody?.message || '').toString().toLowerCase().includes('token has expired');
        if (expiredToken) {
          this.handleSessionExpired();
          return throwError(error);
        }
        if (!errBody || errBody.error_description == null) {
          return throwError(error);
        }
        if (errBody.error_description == 'User account is locked') {
          this.errorHandler.showErrorModal('Cuenta de usuario bloqueada');
          return throwError(error);
        }
        if (errBody.error_description == 'Bad credentials') {
          return throwError(error);
        }
        if (req.url.includes('token')) {
          this.errorHandler.showErrorModal('Reintente nuevamente , si el error persiste consulte al administrador');
          return throwError(error);
        }
        if (error.status === 0) {
          this.userApi.auth = null;
          this.userApi.refreshToken().subscribe(() => {
            return next.handle(req);
          }, error => {
            this.userApi.logOut();
            this.router.navigate(["/"]);
            // this.errorHandler.showErrorModal('Inicia sesión  nuevamente');
            return throwError(error);
          });
        } else if (error.status === 401) {
          this.router.navigate(["/"]);
        } else {
          if (error.error && error.error.userMessage) {
            this.errorHandler.showErrorModal(error.error.userMessage);
          } else {
            this.errorHandler.handleServerSideError(error);
          }
          return throwError(error);

        }

      })
    );
  }

  private handleSessionExpired(): void {
    if (this.isRedirecting) {
      return;
    }

    this.isRedirecting = true;

    try {
      this.userApi.logOut();
      sessionStorage.clear();
      localStorage.removeItem('login_response');
    } catch (_) {
      // noop
    }

    const currentUrl = this.router.url || '';
    if (currentUrl !== '/') {
      this.router.navigate(['/'], {
        queryParams: { sessionExpired: 'true' },
      }).finally(() => {
        this.isRedirecting = false;
      });
    } else {
      this.isRedirecting = false;
    }
  }
}
